import React from "react";
import { Tooltip } from "antd";
import { HolderOutlined } from "@ant-design/icons";

function DraggableHeaderCell({
  columnKey,
  isDragging,
  isDragOver,
  onReorder,
  onDragStateChange,
  draggable = true,
  style,
  children,
  ...restProps
}) {
  if (!columnKey || typeof onReorder !== "function" || !draggable) {
    return (
      <th {...restProps} style={style}>
        {children}
      </th>
    );
  }

  const handleDragStart = (event) => {
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = "move";
      try {
        event.dataTransfer.setData("text/plain", String(columnKey));
      } catch {
        // noop
      }
    }
    onDragStateChange?.({ type: "start", columnKey });
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    if (event.dataTransfer) event.dataTransfer.dropEffect = "move";
    onDragStateChange?.({ type: "over", columnKey });
  };

  const handleDragLeave = () => {
    onDragStateChange?.({ type: "leave", columnKey });
  };

  const handleDrop = (event) => {
    event.preventDefault();
    let fromKey = null;
    try {
      fromKey = event.dataTransfer?.getData("text/plain") || null;
    } catch {
      // noop
    }
    if (fromKey) onReorder(fromKey, columnKey);
    onDragStateChange?.({ type: "end" });
  };

  const handleDragEnd = () => {
    onDragStateChange?.({ type: "end" });
  };

  const dragStyle = {
    ...style,
    userSelect: "none",
    opacity: isDragging ? 0.5 : style?.opacity ?? 1,
    boxShadow: isDragOver ? "inset 4px 0 0 0 #1677ff" : style?.boxShadow,
    transition: "box-shadow 120ms ease, opacity 120ms ease",
  };

  const handleIconColor = isDragging || isDragOver ? "#1677ff" : "#012442";

  return (
    <th
      {...restProps}
      style={dragStyle}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          width: "100%",
          justifyContent: "center",
        }}
      >
        <Tooltip title="Arraste para reordenar a coluna">
          <span
            draggable
            onDragStart={handleDragStart}
            onDragEnd={handleDragEnd}
            style={{
              display: "inline-flex",
              alignItems: "center",
              flexShrink: 0,
              cursor: isDragging ? "grabbing" : "grab",
            }}
          >
            <HolderOutlined
              aria-hidden="true"
              style={{
                color: handleIconColor,
                fontSize: 14,
                transition: "color 120ms ease",
              }}
            />
          </span>
        </Tooltip>
        {children}
      </span>
    </th>
  );
}

export default DraggableHeaderCell;
